import { CloudCommand } from "../types.js";

export const setConversationCategory: CloudCommand = {
    action: "CONVERSATION/SET_CATEGORY",
    commandName: "conversation.setConversationCategory",
    buildPayload: ({ params }) => params,
};
